import { useItemContext } from '../../ItemContext';
import { denormalizeDataPoint } from '../charts/charts';
import { getPeriodByPeriodId } from '../history';
import useMetricSummaryChart from './useMetricSummaryChart';
const useFrostMetricsSummaryChart = (prefetch) => {
    const { timezone } = useItemContext();
    const { data: tWetData, isLoading: isLoadingTWet, absoluteYDomain: tWetAbsoluteYDomain, getGradient: getTWetGradient, yDomain: tWetYDomain, xDomain } = useMetricSummaryChart({
        metric: 'T_WET',
        prefetch
    });
    const { data: tDryData, isLoading: isLoadingTDry, absoluteYDomain: tDryAbsoluteYDomain, getGradient: getTDryGradient, yDomain: tDryYDomain } = useMetricSummaryChart({
        metric: 'T_DRY',
        prefetch
    });
    const isLoading = isLoadingTDry || isLoadingTWet;
    const chartDomain = {
        x: xDomain,
        y: [0, 1]
    };
    const min = tWetYDomain[0] < tDryYDomain[0] ? tWetYDomain[0] : tDryYDomain[0];
    const max = tWetYDomain[1] > tDryYDomain[1] ? tWetYDomain[1] : tDryYDomain[1];
    const yDomain = [min, max];
    const denormalizeFct = denormalizeDataPoint(yDomain);
    const period = getPeriodByPeriodId({ periodId: 'current_day', timezone });
    return {
        chartDomain,
        denormalizeFct,
        getTDryGradient,
        getTWetGradient,
        isLoading,
        period,
        tDryAbsoluteYDomain,
        tDryData,
        tWetAbsoluteYDomain,
        tWetData
    };
};
export default useFrostMetricsSummaryChart;
